export default "__VITE_ASSET__BWTI3ewH__"